var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"loading":_vm.loading}},[_c('v-card-text',[(_vm.reservation)?_c('blocking-to-reservation-form',{attrs:{"loading":_vm.loading,"reservation":_vm.reservation},on:{"submit":_vm.createFromBlocking}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }